module.exports = __webpack_public_path__ + "static/media/speaker.1be72689.svg";